<template>
  <ul>
    <li class="title">
      <div class="h4">
        {{ blok.title }}
      </div>
    </li>
    <li v-for="item in blok.items" :key="item._uid">
      <StoryblokComponent :is="item.component" :blok="item" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { NavigationMenuWrapperStoryblok } from '~/types/storyblok'
defineProps<{
  blok: NavigationMenuWrapperStoryblok
}>()
</script>

<style lang="less" scoped>
ul {
  .list-reset();
}
</style>
